<template>
  <div class="rmaForm">
    <div v-if="loading || transportLoading" class="loader loader-positioning" />

    <div v-if="!loading">
      <div v-if="!transportPossible">
        <Radio
          :questionString="$mlGet('rmaTransport-question-hanexShipping')"
          :answer="false"
          :option1Text="$mlGet('rmaTransport-question-hanexShipping-option1')"
          :option2Text="$mlGet('rmaTransport-question-hanexShipping-option2')"
          :disabled="true"
        />

        <div class="information-box">
          <p>
            <span
              v-html="$mlGet('rmaTransport1-informationBox-noTransport')"
            ></span>
          </p>
        </div>
      </div>

      <div v-else>
        <div v-if="pickupExamplePrice">
          <span
            v-if="pickupExamplePrice.upsSpecialRate"
            v-html="$mlGet('rmaTransport1-specialRates')"
          ></span>
          <div
            v-if="
              pickupExamplePrice.price && pickupExamplePrice.warranty == false
            "
          >
            <p>
              <span
                v-if="!pickupExamplePrice.includesTax"
                v-html="
                  $mlGet('rmaTransport1-header-priceBox-pickup-prefix-noBtw')
                "
              ></span>
              <span
                v-if="pickupExamplePrice.includesTax"
                v-html="
                  $mlGet('rmaTransport1-header-priceBox-pickup-prefix-btw')
                "
              ></span>
              <span>{{
                pickupExamplePrice.price
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")
              }}</span>
              <span
                v-html="$mlGet('rmaTransport1-header-priceBox-pickup-suffix')"
              ></span>
            </p>
          </div>
          <div v-if="pickupExamplePrice.warranty == true">
            <span
              v-html="$mlGet('rmaTransport1-header-priceBox-inWarranty')"
            ></span>
          </div>
          <div v-if="!pickupExamplePrice.price">
            <span
              v-html="$mlGet('rmaTransport1-header-priceBox-fallback')"
            ></span>
          </div>
        </div>

        <form v-on:submit.prevent="" style="text-align: left">
          <Radio
            :questionString="$mlGet('rmaTransport-question-hanexShipping')"
            v-on:userInput="handleHanexShipping"
            :answer="$store.state.rma.transportHanexShipping"
            :option1Text="$mlGet('rmaTransport-question-hanexShipping-option1')"
            :option2Text="$mlGet('rmaTransport-question-hanexShipping-option2')"
          />

          <div v-if="$store.state.rma.transportHanexShipping === true">
            <Radio
              :questionString="
                $mlGet('rmaTransport-question-originalPackaging')
              "
              v-on:userInput="handleOriginalPackaging"
              :answer="$store.state.rma.transportOriginalPackaging"
            />

            <Radio
              v-if="$store.state.rma.transportOriginalPackaging === false"
              :questionString="$mlGet('rmaTransport-question-securePacking')"
              v-on:userInput="handleSecurePacking"
              :answer="$store.state.rma.transportSecurePacking"
            />
          </div>
        </form>

        <div class="information-box">
          <p v-if="!$store.state.rma.transportHanexShipping">
            <span v-html="$mlGet('rmaTransport1-informationBox-a')"></span>
          </p>
          <p
            v-if="
              $store.state.rma.transportHanexShipping &&
                $store.state.rma.transportOriginalPackaging
            "
          >
            <span v-html="$mlGet('rmaTransport1-informationBox-b')"></span>
          </p>
          <p
            v-if="
              $store.state.rma.transportHanexShipping &&
                !$store.state.rma.transportOriginalPackaging
            "
          >
            <span v-html="$mlGet('rmaTransport1-informationBox-c')"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import Radio from "@/components/Input/Radio.vue";
import { highlightElementQuerySelector } from "@/helpers/alerts";
import {
  confirmTransport,
  getTransportPrices,
  TransportResponse
} from "@/helpers/transport";
import { PageChangeContext, PageName } from "@/views/CreateRma.vue";

@Component({
  components: {
    Radio
  }
})
export default class RmaTransport1 extends Vue {
  public loading = true;
  public transportLoading = false;

  public transportPossible = false;
  public fieldServicePossible = false;

  public pickupExamplePrice: TransportResponse = null;

  public sizes = {
    height: 0,
    width: 0,
    length: 0,
    weight: 0
  };

  public useSizes = false;

  async mounted(): Promise<void> {
    await this.modelTransportOptions();

    try {
      this.pickupExamplePrice = await getTransportPrices();
    } catch (err) {
      // Unable to get transport prices, model has invalid or insufficient data.
      this.pickupExamplePrice = null;
    }

    this.loading = false;
  }

  async modelTransportOptions() {
    try {
      const {
        data: { transportPossible, fieldServicePossible, sizes, useModelSizes }
      } = await this.$axios.get(
        `/model/${this.$store.state.rma.model.fmId}/transport`
      );

      this.transportPossible = transportPossible;
      this.fieldServicePossible = fieldServicePossible;

      this.useSizes = useModelSizes;
      this.sizes = sizes;

      // If transport is not possible, reset the transport options
      if (!this.transportPossible) {
        this.$store.state.rma.transportHanexShipping = false;
        this.$store.state.rma.transportOriginalPackaging = false;
        this.$store.state.rma.transportSecurePacking = false;
      } else if (this.useSizes === true) {
        this.$store.state.rma.packageHeight = this.sizes.height.toString();
        this.$store.state.rma.packageWidth = this.sizes.width.toString();
        this.$store.state.rma.packageLength = this.sizes.length.toString();
        this.$store.state.rma.packageWeight = this.sizes.weight.toString();
      }
    } catch (err) {
      this.$swal({
        title: this.$mlGet("server-genericError-head"),
        text: this.$mlGet("server-genericError-text"),
        icon: "error"
      });
    }
  }

  handleHanexShipping(answer: boolean): void {
    this.$store.state.rma.transportHanexShipping = answer;
  }
  handleOriginalPackaging(answer: boolean): void {
    this.$store.state.rma.transportOriginalPackaging = answer;
  }
  handleSecurePacking(answer: boolean): void {
    this.$store.state.rma.transportSecurePacking = answer;
  }

  public async beforePageLeave(context: PageChangeContext): Promise<boolean> {
    if (context.isReturnOperation) return true;

    if (
      !this.$store.state.rma.transportOriginalPackaging &&
      !this.$store.state.rma.transportSecurePacking &&
      this.$store.state.rma.transportHanexShipping
    ) {
      this.$store.state.rma.transportHanexShipping = false;
      highlightElementQuerySelector(".rmaForm");
      return false;
    }

    // If the customer handles the transport, we don't check for original packaging and secure packing
    if (!this.$store.state.rma.transportHanexShipping) {
      this.$store.state.rma.transportOriginalPackaging = false;
      this.$store.state.rma.transportSecurePacking = false;
      return true;
    }

    if (this.$store.state.rma.transportOriginalPackaging && this.useSizes) {
      const { height, width, length, weight } = this.sizes;

      this.$store.state.rma.packageHeight = height.toString();
      this.$store.state.rma.packageWidth = width.toString();
      this.$store.state.rma.packageLength = length.toString();
      this.$store.state.rma.packageWeight = weight.toString();

      return await confirmTransport(
        loading => (this.transportLoading = loading)
      );
    }

    return true;
  }

  public async afterPageEnter(context: PageChangeContext): Promise<void> {
    return;
  }

  public async onPageLeave(context: PageChangeContext): Promise<PageName> {
    if (!this.$store.state.rma.transportHanexShipping) {
      return "RmaReferences";
    }

    if (this.$store.state.rma.transportOriginalPackaging && this.useSizes) {
      return "TransportServicepoints";
    }

    return "PackageInformation";
  }
}
</script>

<style scoped>
label {
  margin: 0 20px 0 0;
}

.formRadioQuestion {
  display: block;
  padding-bottom: 2ex;
}

p {
  margin: 3px 0 8px 0;
}

h3 {
  padding: 0;
  margin: 1ex 0 5px 0;
}

.inputField {
  border: 1px solid lightgray;
  box-sizing: border-box;
  padding: 5px;
  margin: 5px 0;
  width: 100%;
  width: 40ex;
}

.button {
  border: none;
  background-color: #da6f38;
  color: white;
  font-size: 110%;
  padding: 3px 5px 5px 5px;
  margin-left: 2px;
  cursor: pointer;
}
</style>
